import styled from 'styled-components';
import {styled as muiStyled} from '@mui/material/styles';
import {COLORS, FONTS, SIZES, Typography} from '@fupa/fupa-uikit';
import {IconButton} from '@mui/material';
import React from 'react';

interface ButtonContainerProps {
  bgColor?: boolean;
  noMargin?: boolean;
  dim?: string;
  show?: boolean;
}

// important styles are necessary to overwrite video-js default styles for buttons...
export const ButtonContainer = muiStyled(IconButton, {
  shouldForwardProp: prop => prop !== 'bgColor' && prop !== 'noMargin' && prop !== 'dim' && prop !== 'show',
})<ButtonContainerProps>(
  ({bgColor, noMargin, dim = '1em', show = true}) => `
  display: flex!important;
  height: ${dim};
  width: ${dim};
  box-sizing: content-box!important;
  background-color: ${bgColor ? 'rgba(0, 0, 0, 0.5)' : 'transparent'}!important;
  margin: ${noMargin ? 'auto 0' : `auto ${SIZES['16']}`};
  align-items: center;
  opacity: ${!show ? '0' : '1'};
  transform: ${!show ? 'scale(0)' : 'scale(1)'};
  transition: transform 0.25s, opacity 0.25s!important;
`
);

export const withDropShadow = (IconComponent: React.ComponentType<any>) => styled(IconComponent)`
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8));
`;
export const withDisabledIcon = (IconComponent: React.ComponentType<any>) => styled(IconComponent)`
  color: rgba(255, 255, 255, 0.5);
`;

export const IconButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${SIZES['48']};
  margin: ${SIZES['8']};
`;

export const IconButtonLabel = styled(Typography)<{$disabled?: boolean}>`
  &&& {
    color: ${props => (props.$disabled ? `rgba(255,255,255, 0.5)` : COLORS.white)};
    font-size: ${FONTS['12']};
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.8));
  }
`;
